import React from 'react';
import { motion } from 'framer-motion';
import { FaBuilding } from 'react-icons/fa';

interface AboutCompanyOverviewSectionProps {
  language?: 'ar' | 'en';
  titleAr?: string;
  titleEn?: string;
  contentAr?: string;
  contentEn?: string;
  image?: string;
}

const AboutCompanyOverviewSection: React.FC<AboutCompanyOverviewSectionProps> = ({
  language = 'ar',
  titleAr = "عن الشركة",
  titleEn = "About Us",
  contentAr = "تأسست شركة مكة البركة للمقاولات العامة عام 2014 في جمهورية مصر العربية لتلبية احتياجات المنطقة العربية في النهضة بالبنية التحتية ومواكبة التطور العالمي، وشاركت الشركة في مشاريع وطنية ضخمة، مثل مشروع قناة السويس الجديدة، واكتسبت سمعة قوية بين الشركات. تخصصت الشركة في أعمال الطرق والمحاجر، وحققت رضا العملاء عبر الالتزام بالجودة والسلامة.",
  contentEn = "Mecca El Baraka For Construction was established in 2014 in the Arab Republic of Egypt to meet the needs of the Arab region in advancing infrastructure and keeping pace with global development. The company has participated in massive national projects, such as the New Suez Canal project, and has gained a strong reputation among companies. The company specialized in road works and quarries, achieving customer satisfaction through commitment to quality and safety.",
  image = "/images/image1.jpg"
}) => {
  const isRTL = language === 'ar';

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                <FaBuilding className="w-6 h-6 text-white" />
              </div>
              <h2 className="text-3xl font-bold text-gray-900">{isRTL ? titleAr : titleEn}</h2>
            </div>
            <p className="text-lg text-gray-700 leading-relaxed">
              {isRTL ? contentAr : contentEn}
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="bg-gradient-to-br from-blue-50 to-gray-100 rounded-2xl p-8">
              <img
                src={image}
                alt="Construction Site"
                className="w-full h-64 object-cover rounded-xl shadow-lg"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutCompanyOverviewSection; 